import ConfirmarInformacionProvider from "../providers/confirmarInformacion-provider";
import TokenProvider from "../../commons/providers/token-provider";

class ConfirmarInformacionRepository {
    
    constructor() {
        this.confirmarInformacionProvider = new ConfirmarInformacionProvider();
        this.tokenProvider = new TokenProvider();
    }

    patchConfirmarInformacion = async (datosConsulta) => {
        await this.tokenProvider.getToken();
        return this.confirmarInformacionProvider.patchConfirmarInformacion(datosConsulta);
    }

}

export default ConfirmarInformacionRepository;